// src/utils/alertas.js
import Swal from "sweetalert2";

/**
 * Muestra una alerta de éxito.
 * @param {Object} options - Opciones para personalizar la alerta.
 * @param {string} options.title - Título de la alerta (por defecto: "¡Correcto!").
 * @param {string} options.message - Mensaje adicional (por defecto: vacío).
 * @param {Function} options.onClose - Función a ejecutar al cerrar la alerta (por defecto recarga la página).
 */
export function showSuccessAlert({
  title = "¡Correcto!",
  message = "",
  onClose = () => {},//window.location.reload(),
} = {}) {
  Swal.fire({
    title: `<span style='font-size: 20px'>${title}</span>`,
    html: `<span style='font-size: 12px'>${message}</span>`,
    type: "success",
    width: "30%",
    confirmButtonText: "Aceptar",
    customClass: {
      confirmButton: "btn-modal-accept",
    },
    onClose,
  });
}

/**
 * Muestra una alerta de error.
 * @param {Object} options - Opciones para personalizar la alerta.
 * @param {string} options.title - Título de la alerta (por defecto: "Error").
 * @param {string} options.message - Mensaje de error (por defecto: "Ocurrió un error.").
 * @param {string} options.imageUrl - URL de la imagen que se mostrará (por defecto: "../static/Cancel_icon.png").
 */
export function showErrorAlert({
  title = "Error",
  message = "Ocurrió un error.",
  imageUrl = "../static/Cancel_icon.png",
  onClose = () => {},
} = {}) {
  Swal.fire({
    title: `<span style='font-size: 20px'>${title}</span>`,
    html: `<span style='font-size: 12px'>${message}</span>`,
    imageUrl,
    imageWidth: "22%",
    imageHeight: "auto",
    width: "30%",
    confirmButtonText: "Aceptar",
    customClass: {
      confirmButton: "btn-modal-accept",
    },
    onClose
  });
}
